import { adapter, getScriptTag } from '@seek/tealium-adapter';
import type { TrackingProps } from '@seek/tealium-adapter/lib-types/types';

import { isProd } from 'src/App/services/environment';

export interface AnalyticsClient {
  link: (eventName: string | string[], props?: TrackingProps) => void;
  view: (eventName: string | string[], props?: TrackingProps) => void;
}

export const initialiseTealiumAdaptor = (environment: string) =>
  getScriptTag({
    account: 'seek',
    profile: 'hirer',
    environment: isProd(environment) ? 'prod' : 'dev',
  });

export const createAnalyticsProvider = (): AnalyticsClient => adapter();
